<h1 *ngIf="contentHeader != null || contentHeader === ''">{{ contentHeader }}</h1>
<div *ngFor="let item of contentRows; let odd = odd">
    <app-row-layout *ngIf="!odd" [rowData]="item" [rowStyle]="'dark'"></app-row-layout>
    <app-row-layout *ngIf="odd" [rowData]="item" [rowStyle]="'light'"></app-row-layout>
</div>
